import IUser from "../entities/IUser";
import Axios from "./Axios";
import { get } from "./HttpApi";
import ENDPOINTS from "./endpoints";

const getAll = async (): Promise<any> => {
  return await get(ENDPOINTS.users.all).then((res) => res);
};

async function getAllUser() {
  return new Promise((resolve) => {
    setTimeout(() => resolve(get(ENDPOINTS.users.all)), 200);
  });
}

const getUsers = () => {
  return Axios.get<Array<IUser>>(ENDPOINTS.users.all);
};

const createUser = (data: IUser) => {
  return Axios.post<IUser>(ENDPOINTS.users.create, data);
};

const updateUser = (id: number, data: IUser) => {
  return Axios.put<IUser>(ENDPOINTS.users.update(id), data);
};

const deleteUser = (id: number) => {
  return Axios.delete(ENDPOINTS.users.delete(id));
};

const getUserById = (id: number) => {
  return Axios.get<IUser>(ENDPOINTS.users.byId(id));
};

const getUserByEmailId = (emailId: string) => {
  return Axios.get<any>(ENDPOINTS.users.byEmailId(emailId));
};

const getUserByName = (name: string) => {
  return Axios.get<any>(ENDPOINTS.users.byName(name));
};

const getUserByEmailAddressNative = (emailId: string) => {
  return Axios.get<any>(ENDPOINTS.users.byEmailAddressNative(emailId));
};

const findByVendorName = (name: string) => {
  return Axios.get<any>(ENDPOINTS.users.byVendorName(name));
};

const findByFirstName = (name: string) => {
  return Axios.get<any>(ENDPOINTS.users.byFirstName(name));
};

const UserServiceApi = {
  getAll,
  get,
  getAllUser,
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getUserById,
  getUserByEmailId,
  getUserByName,
  getUserByEmailAddressNative,
  findByVendorName,
  findByFirstName,
};

export default UserServiceApi;
